import moment from "moment"

const timeDiffBetweenDates = (from, to) => {
  const start = moment(from)
  const end = moment(to)

  // Calcular la diferencia en minutos
  const duration = moment.duration(end.diff(start))

  // Obtener horas y minutos
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()

  // Formatear como HH:MM
  const formattedDifference = `${String(hours).padStart(2, '0')}:${String(
    minutes
  ).padStart(2, '0')} hs`

  return formattedDifference
}

export default timeDiffBetweenDates
